import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9fba3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "float-left" }, "Client & Cost", -1))
const _hoisted_3 = {
  key: 0,
  class: "float-right"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Managed/Non-managed", -1))
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Client Name", -1))
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Branch Name", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "ml-3" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-7" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Invoice adr. - Line 1", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Line 2", -1))
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Town", -1))
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Postcode", -1))
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-2" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Linked Development", -1))
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = {
  key: 0,
  class: "form-group"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Invoice Branch ", -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-5" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "col-md-1 pt-2" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-11 text-right" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_58 = { class: "col-md-1 mt-auto mb-auto" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1))
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = { class: "col-md-1 pt-2" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-11 text-right" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_77 = {
  class: "row",
  style: {"margin-left":"-12px","margin-right":"-12px"}
}
const _hoisted_78 = { class: "col-md-2 topborder" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-md-12" }
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "W/O number", -1))
const _hoisted_83 = { class: "col-md-1 topborder pr-0" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "W/O document", -1))
const _hoisted_85 = { class: "col-md-7 topborder" }
const _hoisted_86 = {
  key: 0,
  class: "col-form-label",
  style: {"color":"transparent"}
}
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-12" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = {
  key: 0,
  class: "col-md-1 col-form-label"
}
const _hoisted_91 = {
  key: 1,
  class: "col-md-1 col-form-label"
}
const _hoisted_92 = {
  key: 2,
  class: "col-md-2 col-form-label"
}
const _hoisted_93 = {
  key: 4,
  class: "col-md-4 col-form-label"
}
const _hoisted_94 = { class: "col-md-1" }
const _hoisted_95 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_96 = { class: "col-md-2" }
const _hoisted_97 = ["value", "onChange", "placeholder", "disabled"]
const _hoisted_98 = { class: "col-md-2" }
const _hoisted_99 = { class: "input-group" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "£")
], -1))
const _hoisted_101 = ["value", "onChange"]
const _hoisted_102 = { class: "col-md-1" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_104 = { class: "col-1" }
const _hoisted_105 = ["onClick"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-md-2 pr-0" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_111 = { class: "col-md-2 topborder" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Price list", -1))

import {
  computed,
  inject,
  ref,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount, 
  onUnmounted,
} from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import moment from "moment-timezone";
import {
  Customer,
  Landlord,
  Bookedby,
  Address,
  Report,
  Fee,
  Dictionary,
  Booking,
  User,
} from "@/models";
import Ably from "ably";
import { DxSwitch } from "devextreme-vue/switch";
import { DxDateBox } from "devextreme-vue/date-box";
import { useRoute } from "vue-router";
import Documents from "@/components/document/Documents.vue";
import ProgressButton from "@/components/ProgressButton.vue";
import WorksordernotesDialog from "@/components/modals/WorksorderNotesModal.vue";
import MiscNotesDialog from "@/components/modals/MiscNotesDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'WhoForHowMuch',
  emits: [
  "showpricelistdocument",
  "showworksorderdocument",
  "showpricelistdocument",
],
  setup(__props, { emit: __emit }) {

const store = useStore();
const toasted = useToast();
const route = useRoute();
const realtime: Ably.Realtime = inject("realtime");
const actProperty: any = inject("actProperty");
const channel = realtime.channels.get("diary");
const deviceid = actProperty.getDeviceId();

const emit = __emit;

// Refs for reactive variables
const selectedCompanyName = ref("");
const selectedBranchName = ref("");
const selectedInvoiceBranchName = ref("");
const clientnamesearchfilter = ref("");
const branchnamesearchfilter = ref("");
const companyNameOptions = ref([]);
const branchNameOptions = ref([]);
const managedtypeOptions = ref(["Managed", "Non-managed"]);
const custPoliciesMiscNotesDialog = ref(null);

const llname = ref(null);
const defaultFee = ref(null);
const worksordernotesModal = ref(null);

const dynamicRefs = ref({});
const expanded = ref(false);
const development = computed(
  () => store.getters["diary/development"] as Customer
);
const customer = computed(() => store.getters["diary/customer"] as Customer);
const _managedtype = computed(
  () => store.getters["diary/managedtype"] as string
);
const landlordsarray = computed(
  () => store.getters["diary/landlordsarray"] as Landlord[]
);
const bookedbyarray = computed(
  () => store.getters["diary/bookedbyarray"] as Bookedby[]
);
const _worksorder = computed(() => store.getters["diary/worksorder"] as string);
const _paid = computed(() => store.getters["diary/paid"] as boolean);
const paymentdate = computed(
  () => store.getters["diary/paymentdate"] as string
);
const invoices = computed(() => store.getters["diary/invoices"] as Report[]);
const dictionary = computed(
  () => store.getters["dictionary/current"] as Dictionary
);
const jobtypeslug = computed(() => store.getters["diary/jobtype"] as string);
const booking = computed(() => store.getters["diary/booking"] as Booking);
const _keypickupbranchname = computed(
  () => store.getters["diary/keypickupbranchname"] as string
);
const agencyaddress = computed(
  () => store.getters["diary/agencyaddress"] as Address
);
const customers = computed(
  () => store.getters["diary/customerlist"] as Customer[]
);
const setDevelopment = (development: Customer) => {
  store.commit("diary/setDevelopment", development);
};

const setCustomer = (customer: Customer) => {
  store.commit("diary/setCustomer", customer);
};

const setInvoiceCustomer = (customer: Customer) => {
  store.commit("diary/setInvoiceCustomer", customer);
};

const setAgencyaddress = (address: Address) => {
  store.commit("diary/setAgencyaddress", address);
};

const setKeypickupbranchname = (keypickup: string) => {
  store.commit("diary/setKeypickupbranchname", keypickup);
};

const setReleasekeystobranchname = (releasekeysto: string) => {
  store.commit("diary/setReleasekeystobranchname", releasekeysto);
};

const setManagedtype = (managedtype: string) => {
  setBookingDeep({ path: "companyName", data: '' });
  setCustomer(new Customer());
  setBookingDeep({
    path: `agencyaddress`,
    data:new Address
  });
  selectedCompanyName.value = "";
  selectedBranchName.value = "";
  store.commit("diary/setManagedtype", managedtype);
};

const addStateLandlord = (landlord: Landlord) => {
  store.commit("diary/addLandlord", landlord);
};
const removeLandlord = (landlord: Landlord) => {
  store.commit("diary/removeLandlord", landlord);
};

const addStateBookedby = (bookedby: Bookedby) => {
  store.commit("diary/addBookedby", bookedby);
};

const removeBookedby = (bookedby: Bookedby) => {
  store.commit("diary/removeBookedby", bookedby);
};

const setWorksorder = (worksorder: string) => {
  store.commit("diary/setWorksorder", worksorder);
};

const setPaymentinadv = (paymentinadv: boolean) => {
  store.commit("diary/setPaymentinadv", paymentinadv);
};

const setPaid = (paid: boolean) => {
  store.commit("diary/setPaid", paid);
};

const setPaymentdate = (paymentdate: string) => {
  store.commit("diary/setPaymentdate", paymentdate);
};

const addUnsavedChange = (element: string) => {
  store.commit("diary/addUnsavedChange", element);
};

const setBookingDeep = (payload: { path: string; data: any }) => {
  return store.commit("diary/setBookingDeep", payload);
};

const addInvoice = (invoice: Report) => {
  return store.commit("diary/addInvoice", invoice);
};

const removeInvoiceFromState = (index: number) => {
  return store.commit("diary/removeInvoice", index);
};

const removeRequest = (id: string) => {
  store.commit("app/removeRequest", id);
};

const setSelectedcustomername = (name: string) => {
  store.commit("diary/setSelectedcustomername", name);
};

const downloadNormalInvoice = async (report: Report): Promise<any> => {
  return store.dispatch("reports/downloadInvoice", report);
};

const downloadProformaInvoice = async (report: Report): Promise<any> => {
  return store.dispatch("reports/downloadProformaInvoice", report);
};

const getCompanyNameOptions = (managedtype?: string): Promise<any> => {
  return store.dispatch("diary/getCompanyNameOptions", managedtype);
};

const setAgencyaddressDeep = (payload: { path: string; data: string }) => {
  store.commit("diary/setAgencyaddressDeep", payload);
};

const getCustomers = async (payload?: {
  starts_with?: string;
  company_name?: string;
  branch_name?: string;
  managedtype?: string;
}): Promise<Customer[]> => {
  return await store.dispatch("diary/getCustomers", payload);
};

const getBranchNameOptionsWithManagedtype = async (payload?: {
  company_name?: string;
  managedtype?: string;
}): Promise<any> => {
  return await store.dispatch(
    "diary/getBranchNameOptionsWithManagedtype",
    payload
  );
};

const getUserForCustomer = (customer: Customer): Promise<User> => {
  return store.dispatch("usermanagement/getUserForCustomer", customer);
};

onMounted(() => {
  channel.subscribe("commoncovertapplied", async (message: any) => {
    if (message?.data) {
      // Make sure the event is coming from the same pc
      if (message.data.deviceid != deviceid) return;
      if (message.data.bookingid != booking.value.id) return;
      await loadcompanyandbranchoptions();
      setManagedtype(booking.value.managedtype);
      if (booking.value?.customer?.companyName) {
        selectedCompanyName.value = booking.value.customer.companyName;
        setSelectedcustomername(booking.value.customer.companyName);
      } else if (booking.value?.companyName) {
        selectedCompanyName.value = booking.value.companyName;
        setSelectedcustomername(booking.value.companyName);
      }
      if (booking.value.customer.companyName != "Private Landlord")
        setAgencyaddress(new Address(booking.value.customer.address));
      setPaymentinadv(booking.value.customer.accountsettings.pobinvoice);
    }
  });

  setTimeout(() => {
    getCompanyNameOptions(booking.value.managedtype).then(
      (options: any) => (companyNameOptions.value = options)
    );
    if (invoices.value.length === 0) {
      nextTick(() => {
        let element: HTMLElement = defaultFee.value as HTMLElement;
        if (element) element.click();
      });
    }
  }, 1000);
});

onBeforeUnmount(() => {
  channel.unsubscribe('commoncovertapplied');
});

const clearform = () => {
  selectedCompanyName.value = "";
  selectedBranchName.value = "";
  invoiceBranchName.value = "";
  clientnamesearchfilter.value = "";
  branchnamesearchfilter.value = "";
  llname.value = null;
  defaultFee.value = null;
};

watch(
  () => booking.value.id,
  async () => {
    clearform();
    loadcompanyandbranchoptions();
    selectedCompanyName.value = booking.value?.customer?.companyName
      ? booking.value?.customer?.companyName
      : booking.value?.companyName;
    selectedBranchName.value = booking.value.customer.branchName;
    selectedInvoiceBranchName.value = booking.value?.invoicecustomer?.branchName;
  }
);
const loadcompanyandbranchoptions = async () => {
  await getCompanyNameOptions(managedtype.value).then(
    (options: any) => (companyNameOptions.value = options)
  );
  await getBranchNameOptionsWithManagedtype({
    company_name: booking.value?.customer?.companyName,
    managedtype: managedtype.value,
  }).then((options: any) => (branchNameOptions.value = options));
};

const customerCompanyName = computed({
  get: () => selectedCompanyName.value,
  set: (name: string) => {
    selectedCompanyName.value = name;
  },
});

const filteredcompanynameOptions = computed(() => {
  return companyNameOptions.value.filter((c: string) => {
    if (clientnamesearchfilter.value)
      return c
        .toLowerCase()
        .startsWith(clientnamesearchfilter.value.toLowerCase());
    else return true;
  });
});

const customerBranchName = computed({
  get: () => selectedBranchName.value,
  set: (name: string) => {
    selectedBranchName.value = name;
  },
});

const invoiceBranchName = computed({
  get: () => selectedInvoiceBranchName.value,
  set: (name: string) => {
    selectedInvoiceBranchName.value = name;
  },
});


const filteredbranchnameOptions = computed(() => {
  return branchNameOptions.value.filter((b: string) => {
    if (branchnamesearchfilter.value)
      return b
        .toLowerCase()
        .startsWith(branchnamesearchfilter.value.toLowerCase());
    else return true;
  });
});

const selectedDevelopment = computed({
  get: () => {
    let selected = "";
    if (customer.value && customer.value.establishments) {
      let dev = customer.value.establishments.find(
        (e) => e.id === development.value.id
      );
      if (dev) selected = dev.companyName;
    }
    return selected;
  },
  set: (val: string) => {
    if (customer.value && customer.value.establishments) {
      let dev = customer.value.establishments.find(
        (e) => e.companyName === val
      );
      if (dev) {
        setDevelopment(dev); // Assuming setDevelopment is a method defined elsewhere
      } else {
        setDevelopment(new Customer());
      }
    }
  },
});

const developmentOptions = computed(() => {
  let options: string[] = [];
  if (customer.value && customer.value.establishments) {
    options = customer.value.establishments.map((e) => e.companyName);
  }
  return options;
});

const customerListName = computed(() => {
  let options: string[] = [];
  if (
    customer.value &&
    booking.value.customer.companyName != "Private Landlord" &&
    customer.value.policies.contactlist.length
  ) {
    options = customer.value.policies.contactlist.map((m: any) => m.name);
  }
  return options;
});

const onSelectDevelopment = (val: string) => {
  selectedDevelopment.value = val;
};

const onSelectCompanyName = async (companyName: string) => {
  if (companyName) {
    setSelectedcustomername(companyName);
    setBookingDeep({ path: "companyName", data: companyName });
    selectedCompanyName.value = companyName;
    selectedBranchName.value = "";
    selectedInvoiceBranchName.value = "";
    setCustomer(new Customer());
    branchNameOptions.value = customers.value
      .filter((c1: Customer) => {
        if (managedtypeboolean.value) {
          return c1.companyName === companyName && c1.acClientCode != "NM";
        } else {
          return (
            c1.companyName === companyName &&
            (c1.acClientCode == "NM" || c1.acClientCode === "MISC")
          );
        }
      })
      .map((c2: Customer) => c2.branchName);
  }
};

const onSelectBranchName = async (branchName: string) => {
  const customer = customers.value.find((c: Customer) => {
    return (
      c.companyName === selectedCompanyName.value && c.branchName === branchName
    );
  });
  if (customer) {
    selectedBranchName.value = branchName;
    setCustomer(customer);
    if (selectedCompanyName.value != "Private Landlord")
      setAgencyaddress(new Address(customer.address));
    setPaymentinadv(customer.accountsettings.pobinvoice);
    if(isNewBooking()){
      setBookingDeep({path:'pinotes',data:customer.policies.longtermpinotes});
    }
  }
  if (
    booking.value.jobtype === "inventory" ||
    booking.value.jobtype === "checkin"
  ) {
    setBookingDeep({
      path: "donotcontacttt",
      data: customer.policies.donotcontactttforinvci,
    });
  } else if (
    booking.value.jobtype === "checkout" ||
    booking.value.jobtype === "soc"
  ) {
    setBookingDeep({
      path: "donotcontacttt",
      data: customer.policies.donotcontactttforcosoc,
    });
  }

};

const paymentAdvanceFlag = computed(() => {
  let paymentAdvanceFlag = false;
  if (booking.value.jobtype === "checkout" || booking.value.jobtype === "soc") {
    paymentAdvanceFlag = customer.value.accountsettings.paymentinadvcosoc;
  } else if (
    booking.value.jobtype === "inventory" ||
    booking.value.jobtype === "checkin"
  ) {
    paymentAdvanceFlag = customer.value.accountsettings.paymentinadvinvci;
  }
  return paymentAdvanceFlag;
});

const clearCustomer = async () => {
  booking.value.companyName = "";
  selectedCompanyName.value = "";
  selectedBranchName.value = "";
  selectedInvoiceBranchName.value = "";
  setCustomer(new Customer());
  setAgencyaddress(new Address());
  setKeypickupbranchname("");
  setReleasekeystobranchname("");
};

const clearBranch = async () => {
  selectedBranchName.value = "";
  selectedInvoiceBranchName.value = "";
  setCustomer(new Customer());
  setAgencyaddress(new Address());
  setKeypickupbranchname("");
  setReleasekeystobranchname("");
};

const hqbranch = () => {
  return customer.value.hqbranch;
};

const onSelectInvoiceBranchName = async (branchName: string) => {
  const customers: Customer[] = await getCustomers({
    company_name: customerCompanyName.value,
    branch_name: branchName || "empty",
    managedtype: managedtype.value || "Non-managed",
  });

  if (customers.length) {
    invoiceBranchName.value = branchName;
  }

  if (customers.length) {
    let customer = customers[0];
    setInvoiceCustomer(customer);

    if (!_keypickupbranchname.value) {
      setAgencyaddress(new Address(customer.address));
    }
    setPaymentinadv(customer.accountsettings.pobinvoice);
  }
};

const clearInvoiceCustomer = () => {
  invoiceBranchName.value = "";
  selectedInvoiceBranchName.value = "";
  setInvoiceCustomer(new Customer());
  onSelectBranchName(selectedBranchName.value);
};

// Computed properties
const managedtype = computed({
  get: () => _managedtype.value,
  set: (val: string) => setManagedtype(val),
});

const managedtypeboolean = computed(() => {
  return _managedtype.value === "Managed";
});

const setManagedtypeString = async (mt: string) => {
  setManagedtype(mt);
  setBookingDeep({ path: "companyName", data: '' });
  setCustomer(new Customer());
  setBookingDeep({
    path: `agencyaddress`,
    data:new Address
  });
  selectedCompanyName.value = "";
  selectedBranchName.value = "";
  await getCompanyNameOptions(mt).then(
    (options: any) => (companyNameOptions.value = options)
  );
  await getBranchNameOptionsWithManagedtype({
    company_name: selectedCompanyName.value,
    managedtype: mt,
  }).then((options: any) => (branchNameOptions.value = options));
};

const agencyaddressLine1 = computed({
  get: () => agencyaddress.value.line1,
  set: (data: string) => setAgencyaddressDeep({ path: "line1", data }),
});

const agencyaddressLine2 = computed({
  get: () => agencyaddress.value.line2,
  set: (data: string) => setAgencyaddressDeep({ path: "line2", data }),
});

const agencyaddressTown = computed({
  get: () => agencyaddress.value.town,
  set: (data: string) => setAgencyaddressDeep({ path: "town", data }),
});

const agencyaddressPostcode = computed({
  get: () => agencyaddress.value.postcode,
  set: (data: string) => setAgencyaddressDeep({ path: "postcode", data }),
});

const worksorder = computed({
  get: () => _worksorder.value,
  set: (val: string) => setWorksorder(val),
});

const paid = computed({
  get: () => _paid.value,
  set: (val: boolean) => setPaid(val),
});

const setPaymentDate = (e: any) => {
  setPaymentdate(moment(e.value).format("YYYY-MM-DD[T]HH:mm"));
};

const jobtype = computed(() => {
  let displayname = "";
  if (dictionary.value && dictionary.value.reporttypes) {
    const type = dictionary.value.reporttypes.find(
      (t) => t.slug === jobtypeslug.value
    );
    if (type) displayname = type.displayname;
  }
  return displayname;
});

const setPaymentDateToToday = (paid: boolean) => {
  if (paid) setPaymentdate(moment(new Date()).format("YYYY-MM-DD[T]HH:mm"));
};

const setFeesDetail = (index: number, $event: any) => {
  setBookingDeep({
    path: `invoices[${index}].fees[0].name`,
    data: $event.target.value,
  });
};

const setFeesValue = (index: number, $event: any) => {
  setBookingDeep({
    path: `invoices[${index}].fees[0].amount`,
    data: $event.target.value,
  });
};

const setFeesPaid = (index: number, $event: any) => {
  setBookingDeep({
    path: `invoices[${index}].fees[0].paid`,
    data: $event,
  });
};
const setFeesPaymentDate = (index: number, $event: any) => {
  setBookingDeep({
    path: `invoices[${index}].fees[0].paymentdate`,
    data: moment($event).format("YYYY-MM-DD[T]HH:mm"),
  });
};
const addNewInvoice = () => {
  addInvoice(new Report({ fees: [new Fee()] }));
};

const removeInvoice = (index: number) => {
  actProperty.confirmPrompt().then(() => {
    removeInvoiceFromState(index);
  });
};

const downloadInvoice = (report: Report, requestId: string) => {
  if (report && report.fees) {
    let fee = report.fees[0];
    if (!fee.name) {
      downloadProformaInvoice(report)
        .then((key: string) => {
          actProperty.downloadAttachment(key);
          toasted.success(`Proforma invoice ${report.ref} PDF downloaded`);
        })
        .finally(() => removeRequest(requestId))
        .catch((err: any) => actProperty.displayError(err));
    } else {
      downloadNormalInvoice(report)
        .then((key: string) => {
          actProperty.downloadAttachment(key);
          toasted.success(`Invoice ${report.ref} PDF downloaded`);
        })
        .finally(() => removeRequest(requestId))
        .catch((err: any) => actProperty.displayError(err));
    }
  }
};
const hqpostfix = (branchName: string): string => {
  let val = "";
  const customer = customers.value.find(
    (c: Customer) =>
      c.companyName === selectedCompanyName.value && c.branchName === branchName
  );
  if (customer && customer.hqbranch) {
    val = "(HQ)";
  }
  return val;
};

const addLandlord = () => {
  addStateLandlord(new Landlord());
};

const addBookedby = () => {
  addStateBookedby(new Bookedby());
};

const showWorksorderDocument = (index: number) => {
  emit("showworksorderdocument", index);
};

const showWorksordernotesModal = () => {
  const modal = worksordernotesModal.value;
  if (modal) {
    modal.init();
    modal.show();
  }
};

const worksordernotesPresent = () => {
  let plaintext = "";
  if (booking.value.worksordernotes) {
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = booking.value.worksordernotes;
    plaintext = tempDivElement.textContent || tempDivElement.innerText || "";
  }
  return plaintext.trim().length > 0;
};

const showPricelistDocument = (index: number) => {
  emit("showpricelistdocument", index);
};

const dropDownOpened = (refName: string) => {
  nextTick(() => {
    const multiselect = dynamicRefs.value[refName];
    const dropdownList = multiselect?.$el.querySelector(
      ".multiselect__content-wrapper"
    );

    const selectedOption = multiselect?.$el.querySelector(
      ".multiselect__option--selected"
    );

    if (selectedOption?.offsetTop) {
      dropdownList.scrollTop = selectedOption.offsetTop;
    }
  });
};

const copyLLContactToBB = () => {
  if (
    !booking.value.bookedbyname &&
    !booking.value.bookedbyemail &&
    !booking.value.bookedbymobile
  ) {
    for (let i = 0; i < booking.value.bookedby.length; i++) {
      if (booking.value.landlords.length > i) {
        let landlord: Landlord = booking.value.landlords[i];
        if (landlord.llname) {
          setBookingDeep({
            path: `bookedby[${i}].bbname`,
            data: landlord.llname,
          });
        }
        if (landlord.llemail) {
          setBookingDeep({
            path: `bookedby[${i}].bbemail`,
            data: landlord.llemail,
          });
        }
        if (landlord.llmobile) {
          setBookingDeep({
            path: `bookedby[${i}].bbmobile`,
            data: landlord.llmobile,
          });
        }
      }
    }
  }
};

const isNewBooking = () => {
  return route.params.id == "new";
};

const creditapproved = computed({
  get: () => booking.value.creditapproved,
  set: (data) => setBookingDeep({ path: "creditapproved", data }),
});

const showCustomerPoliciesMiscNotesDialog = () => {
  const modal = custPoliciesMiscNotesDialog.value as any;
  modal.show();
};

const onTagBookName = (val: string, index: number) => {
  if (index >= 0) {
    setBookingDeep({ path: `bookedby[${index}].bbname`, data: val });
  }
};

const selectBook = (suggestion: string, index: number) => {
  let data = customer.value.policies.contactlist.find(
    (m: any) => suggestion === m.name
  );
  if (data) {
    setBookingDeep({
      path: `bookedby[${index}].bbname`,
      data: data.name,
    });
    setBookingDeep({
      path: `bookedby[${index}].bbmobile`,
      data: data.mobile,
    });
    setBookingDeep({
      path: `bookedby[${index}].bbemail`,
      data: data.email,
    });
  }
};
const clearData = (index: number) => {
  let bookedby = bookedbyarray.value[index].bbname;
  let data = customer.value.policies.contactlist.find(
    (m: any) => bookedby === m.name
  );
  if (index >= 0) {
    setBookingDeep({
      path: `bookedby[${index}].bbname`,
      data: "",
    });
    if (data) {
      setBookingDeep({
        path: `bookedby[${index}].bbmobile`,
        data: "",
      });
      setBookingDeep({
        path: `bookedby[${index}].bbemail`,
        data: "",
      });
    }
  }
};

const portfoliouser = ref();
watch(
  () => booking.value.customer.id,
  async () => {
    portfoliouser.value = await getUserForCustomer(booking.value.customer);
});


return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: "card-header booking-section-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _hoisted_2,
      (portfoliouser.value && portfoliouser.value.name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Portfolio belongs to " + _toDisplayString(portfoliouser.value.name), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createVNode(_component_singleselect_text, {
                modelValue: managedtype.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((managedtype).value = $event)),
                options: managedtypeOptions.value,
                onSelect: setManagedtypeString
              }, _createSlots({ _: 2 }, [
                (managedtype.value)
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setManagedtype('')), ["prevent","stop"])),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear"
                        }, null, 32)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createVNode(_component_singleselect_text, {
                modelValue: customerCompanyName.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customerCompanyName).value = $event)),
                options: filteredcompanynameOptions.value,
                "allow-empty": true,
                taggable: false,
                onSelect: onSelectCompanyName,
                ref: 
                  (el) => {
                    dynamicRefs.value['clientNameDropDown'] = el;
                  }
                ,
                onOpen: _cache[5] || (_cache[5] = ($event: any) => (dropDownOpened('clientNameDropDown'))),
                onSearchChange: _cache[6] || (_cache[6] = ($event: any) => (clientnamesearchfilter.value = $event))
              }, _createSlots({ _: 2 }, [
                (
                    customerCompanyName.value != null && customerCompanyName.value.length
                  )
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (clearCustomer()), ["prevent","stop"])),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear Company Name"
                        }, null, 32)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", null, [
              _createVNode(_component_singleselect_text, {
                modelValue: customerBranchName.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customerBranchName).value = $event)),
                options: filteredbranchnameOptions.value,
                "allow-empty": true,
                disabled: 
                  customerCompanyName.value == null || customerCompanyName.value.length < 1
                ,
                taggable: false,
                onSelect: onSelectBranchName,
                ref: 
                  (el) => {
                    dynamicRefs.value['branchNameDropDown'] = el;
                  }
                ,
                onOpen: _cache[9] || (_cache[9] = ($event: any) => (dropDownOpened('branchNameDropDown'))),
                onSearchChange: _cache[10] || (_cache[10] = ($event: any) => (branchnamesearchfilter.value = $event))
              }, _createSlots({
                singleLabel: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(props.option) + " " + _toDisplayString(hqpostfix(props.option)), 1)
                  ])
                ]),
                option: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(props.option) + " " + _toDisplayString(hqpostfix(props.option)), 1)
                  ])
                ]),
                _: 2
              }, [
                (customerBranchName.value != null && customerBranchName.value.length)
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (clearBranch()), ["prevent","stop"])),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear Branch Name"
                        }, null, 32)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "options", "disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((agencyaddressLine1).value = $event)),
                autocomplete: "agencyaddressLine1",
                disabled: !booking.value.customer.editable
              }, null, 8, _hoisted_23), [
                [
                  _vModelText,
                  agencyaddressLine1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((agencyaddressLine2).value = $event)),
                autocomplete: "agencyaddressLine2",
                disabled: !booking.value.customer.editable
              }, null, 8, _hoisted_26), [
                [
                  _vModelText,
                  agencyaddressLine2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((agencyaddressTown).value = $event)),
                autocomplete: "agencyaddressTown",
                disabled: !booking.value.customer.editable
              }, null, 8, _hoisted_29), [
                [
                  _vModelText,
                  agencyaddressTown.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((agencyaddressPostcode).value = $event)),
                autocomplete: "agencyaddressPostcode",
                disabled: !booking.value.customer.editable
              }, null, 8, _hoisted_32), [
                [
                  _vModelText,
                  agencyaddressPostcode.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", { class: "col-md-2" }, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: showCustomerPoliciesMiscNotesDialog
          }, " Mics Policies ")
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", null, [
              _createVNode(_component_singleselect_text, {
                modelValue: selectedDevelopment.value,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedDevelopment).value = $event)),
                options: developmentOptions.value,
                "allow-empty": true,
                taggable: false,
                onSelect: onSelectDevelopment
              }, _createSlots({ _: 2 }, [
                (selectedDevelopment.value)
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (onSelectDevelopment('')), ["prevent","stop"])),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear Company Name"
                        }, null, 32)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          hqbranch
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", null, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: invoiceBranchName.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((invoiceBranchName).value = $event)),
                    options: branchNameOptions.value,
                    "allow-empty": true,
                    disabled: 
                  customerCompanyName.value == null || customerCompanyName.value.length < 1
                ,
                    taggable: false,
                    onSelect: onSelectInvoiceBranchName
                  }, _createSlots({ _: 2 }, [
                    (invoiceBranchName.value.length)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (clearInvoiceCustomer()), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Invoice Branch Name"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(landlordsarray.value, (landlord, $llindex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["row", { 'mt-1': $llindex > 0 }]),
              key: $llindex
            }, [
              _createElementVNode("div", _hoisted_42, [
                ($llindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_43, "Landlord Name"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "llname",
                  ref_for: true,
                  ref_key: "llname",
                  ref: llname,
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": ($event: any) => ((landlord.llname) = $event),
                  onChange: _cache[19] || (_cache[19] = ($event: any) => (addUnsavedChange('llname')))
                }, null, 40, _hoisted_44), [
                  [
                    _vModelText,
                    landlord.llname,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                ($llindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_46, "Landlord Email"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": ($event: any) => ((landlord.llemail) = $event),
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (addUnsavedChange('llemail'))),
                  autocomplete: "llemail"
                }, null, 40, _hoisted_47), [
                  [
                    _vModelText,
                    landlord.llemail,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                ($llindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_49, "Landlord Mobile"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": ($event: any) => ((landlord.llmobile) = $event),
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (addUnsavedChange('llmobile'))),
                  autocomplete: "llmobile"
                }, null, 40, _hoisted_50), [
                  [
                    _vModelText,
                    landlord.llmobile,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                ($llindex > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: _withModifiers(($event: any) => (removeLandlord(landlord)), ["prevent"])
                    }, _hoisted_54, 8, _hoisted_52))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary mt-2",
                onClick: _withModifiers(addLandlord, ["prevent"])
              }, [
                _hoisted_57,
                _createTextVNode(" Add ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (copyLLContactToBB()), ["prevent"])),
            disabled: 
              booking.value.bookedbyname?.length > 0 ||
              booking.value.bookedbyemail?.length > 0 ||
              booking.value.bookedbymobile?.length > 0 ||
              (!booking.value.landlordname &&
                !booking.value.landlordemail &&
                !booking.value.landlordmobile)
            
          }, [
            _createTextVNode(" Copy "),
            _hoisted_60
          ], 8, _hoisted_59)
        ]),
        _createElementVNode("div", _hoisted_61, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookedbyarray.value, (bookedby, $bbindex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["row", { 'mt-1': $bbindex > 0 }]),
              key: $bbindex
            }, [
              _createElementVNode("div", _hoisted_62, [
                ($bbindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_63, "Booked By Name"))
                  : _createCommentVNode("", true),
                _createVNode(_component_multiselect_text, {
                  modelValue: bookedby.bbname,
                  "onUpdate:modelValue": ($event: any) => ((bookedby.bbname) = $event),
                  options: customerListName.value,
                  "allow-empty": true,
                  taggable: true,
                  id: $bbindex,
                  onTag: onTagBookName,
                  onSelect: ($event: any) => (selectBook(bookedby.bbname, $bbindex))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "id", "onSelect"])
              ]),
              _createElementVNode("div", _hoisted_64, [
                ($bbindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_65, "Booked By Email"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": ($event: any) => ((bookedby.bbemail) = $event),
                  onChange: _cache[23] || (_cache[23] = ($event: any) => (addUnsavedChange('bbemail'))),
                  autocomplete: "email"
                }, null, 40, _hoisted_66), [
                  [
                    _vModelText,
                    bookedby.bbemail,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                ($bbindex === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_68, "Booked By Phone"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": ($event: any) => ((bookedby.bbmobile) = $event),
                  onChange: _cache[24] || (_cache[24] = ($event: any) => (addUnsavedChange('bbmobile'))),
                  autocomplete: "mobile"
                }, null, 40, _hoisted_69), [
                  [
                    _vModelText,
                    bookedby.bbmobile,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                ($bbindex > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: _withModifiers(($event: any) => (removeBookedby(bookedby)), ["prevent"])
                    }, _hoisted_73, 8, _hoisted_71))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary mt-2",
                onClick: _withModifiers(addBookedby, ["prevent"])
              }, [
                _hoisted_76,
                _createTextVNode(" Add ")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: "form-control height-43",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((worksorder).value = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    worksorder.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("span", null, [
            _hoisted_84,
            (_openBlock(), _createBlock(Documents, {
              style: {"margin-top":"0px !important"},
              buttontext: 'Upload',
              entity: 'booking',
              key: booking.value.worksorderdocuments.length,
              documents: booking.value.worksorderdocuments,
              path: 'worksorderdocuments',
              onClicked: showWorksorderDocument
            }, null, 8, ["documents"]))
          ]),
          _createElementVNode("span", null, [
            (!worksordernotesPresent())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["btn btn-sm btn-outline-secondary mt-2", { 'yellow-outline': worksordernotesPresent() }]),
                  onClick: _withModifiers(showWorksordernotesModal, ["prevent"])
                }, " Text content ", 2))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: "far fa-4x fa-file-alt mt-2",
                  onClick: _withModifiers(showWorksordernotesModal, ["prevent"])
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          (invoices.value.length === 0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_86, "."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoices.value, (invoice, $invoiceindex) => {
            return (_openBlock(), _createElementBlock("div", { key: $invoiceindex }, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    ($invoiceindex === 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_90, "Paid"))
                      : _createCommentVNode("", true),
                    (paymentAdvanceFlag.value && $invoiceindex === 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_91, "Credit approved"))
                      : _createCommentVNode("", true),
                    ($invoiceindex === 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_92, "Payment Date"))
                      : _createCommentVNode("", true),
                    ($invoiceindex === 0)
                      ? (_openBlock(), _createElementBlock("label", {
                          key: 3,
                          class: _normalizeClass([paymentAdvanceFlag.value ? 'col-md-4' : 'col-md-5', "col-form-label"])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    ($invoiceindex === 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_93, "(Not inclusive of VAT)"))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoice.fees, (fee, $feeindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: $feeindex,
                      class: "row mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_94, [
                        _createVNode(_unref(DxSwitch), {
                          class: "height-43",
                          value: fee.paid,
                          onValueChanged: ($event: any) => (setFeesPaid($invoiceindex, $event.value))
                        }, null, 8, ["value", "onValueChanged"])
                      ]),
                      (paymentAdvanceFlag.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            ($invoiceindex === 0)
                              ? (_openBlock(), _createBlock(_unref(DxSwitch), {
                                  key: 0,
                                  class: "height-43",
                                  value: creditapproved.value,
                                  onValueChanged: _cache[26] || (_cache[26] = ($event: any) => (creditapproved.value = $event.value))
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_unref(DxDateBox), {
                          class: "form-control height-43",
                          value: fee.paymentdate,
                          "display-format": "dd/MM/yyyy",
                          type: "date",
                          "picker-type": "calendar",
                          "apply-value-mode": "instantly",
                          calendarOptions: { firstDayOfWeek: 1 },
                          onValueChanged: ($event: any) => (
                        setFeesPaymentDate($invoiceindex, $event.value)
                      )
                        }, null, 8, ["value", "onValueChanged"])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(paymentAdvanceFlag.value ? 'col-md-4' : 'col-md-5')
                      }, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control height-43",
                          value: fee.name,
                          onChange: ($event: any) => (setFeesDetail($invoiceindex, $event)),
                          placeholder: $invoiceindex === 0 ? jobtype.value : '',
                          disabled: $invoiceindex === 0
                        }, null, 40, _hoisted_97)
                      ], 2),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control height-43",
                            size: "6",
                            value: fee.amount,
                            onChange: ($event: any) => (setFeesValue($invoiceindex, $event))
                          }, null, 40, _hoisted_101)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        (invoice.id)
                          ? (_openBlock(), _createBlock(ProgressButton, {
                              key: 0,
                              onClick: ($event: any) => (
                        _unref(actProperty).copyDownloadButton(invoice, 'invoice')
                      ),
                              onDblclick: ($event: any) => (downloadInvoice(invoice, $event)),
                              class: "btn btn-outline-primary",
                              title: "Invoice"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_103
                              ]),
                              _: 2
                            }, 1032, ["onClick", "onDblclick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        ($invoiceindex !== 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-outline-danger",
                              onClick: ($event: any) => (removeInvoice($invoiceindex)),
                              tabindex: "-1"
                            }, _hoisted_107, 8, _hoisted_105))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                ref_key: "defaultFee",
                ref: defaultFee,
                onClick: _cache[27] || (_cache[27] = ($event: any) => (addNewInvoice()))
              }, [
                _hoisted_110,
                _createTextVNode(" Fees ")
              ], 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          (booking.value.customer.pricelist.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                _hoisted_113,
                (_openBlock(), _createBlock(Documents, {
                  readonly: true,
                  buttontext: 'Upload',
                  entity: 'booking',
                  key: booking.value.customer.pricelist.length,
                  documents: booking.value.customer.pricelist,
                  path: 'customer.pricelist',
                  onClicked: showPricelistDocument
                }, null, 8, ["documents", "path"]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(WorksordernotesDialog, {
      name: `worksordernotes-modal`,
      ref_key: "worksordernotesModal",
      ref: worksordernotesModal,
      booking: booking.value
    }, null, 8, ["booking"]),
    _createVNode(MiscNotesDialog, {
      ref_key: "custPoliciesMiscNotesDialog",
      ref: custPoliciesMiscNotesDialog,
      modalid: "logiscticsrules",
      title: `Logistics Rules: Misc notes`,
      notes: booking.value.customer.policies.uniquenotes
    }, null, 8, ["notes"])
  ]))
}
}

})